/**
 * Multitab collection slider – class-based web component.
 * Tabs switch collection; each panel is a Swiper. Uses <custom-collection-slider> and .custom-collection-slider-* classes.
 */
(function () {
  class CustomCollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstances = [];
      this._tabClickBound = this._onTabClick.bind(this);
    }

    _onTabClick(index) {
      const tabs = this.querySelectorAll('.custom-collection-slider__tab');
      const panels = this.querySelectorAll('.custom-collection-slider__panel');
      tabs.forEach(function (t, i) {
        t.classList.toggle('custom-collection-slider__tab--active', i === index);
        t.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach(function (p, i) {
        const active = i === index;
        p.classList.toggle('custom-collection-slider__panel--active', active);
        p.hidden = !active;
        if (active && p.swiperInstance) p.swiperInstance.update();
      });
    }

    init() {
      if (typeof window.Swiper === 'undefined') return;

      const tabs = this.querySelectorAll('.custom-collection-slider__tab');
      const panels = this.querySelectorAll('.custom-collection-slider__panel');

      tabs.forEach((tab, index) => {
        tab.removeEventListener('click', this._tabClickBound);
        tab.addEventListener('click', () => this._onTabClick(index));
      });

      this.swiperInstances = [];
      panels.forEach((panel) => {
        const sliderEl = panel.querySelector('.custom-collection-slider__slider');
        if (!sliderEl || sliderEl.swiper) return;

        const prevEl = sliderEl.querySelector('.swiper-button-prev');
        const nextEl = sliderEl.querySelector('.swiper-button-next');

        const swiper = new window.Swiper(sliderEl, {
          speed: 300,
          slidesPerView: 'auto',
          loop: false,
          wrapperClass: 'custom-collection-slider__wrapper',
          slideClass: 'custom-collection-slider__slide',
          navigation:
            prevEl && nextEl
              ? { nextEl: nextEl, prevEl: prevEl }
              : false,
        });
        panel.swiperInstance = swiper;
        this.swiperInstances.push(swiper);
      });
    }

    connectedCallback() {
      if (typeof window.Swiper !== 'undefined') {
        this.init();
        return;
      }
      const onSwiper = () => {
        window.removeEventListener('load', onSwiper);
        if (typeof window.Swiper !== 'undefined') this.init();
      };
      window.addEventListener('load', onSwiper);
    }

    disconnectedCallback() {
      this.swiperInstances.forEach((swiper) => {
        if (swiper && swiper.destroy) swiper.destroy(true, true);
      });
      this.swiperInstances = [];
      const panels = this.querySelectorAll('.custom-collection-slider__panel');
      panels.forEach((p) => {
        p.swiperInstance = null;
      });
    }
  }

  if (!customElements.get('custom-collection-slider')) {
    customElements.define('custom-collection-slider', CustomCollectionSlider);
  }
})();
